import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES, Reveal } from "@/components/site/shared";
import { Marquee } from "@/components/site/Marquee";

const ParallaxPhoto = ({ src, alt, className = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <div ref={ref} className={`overflow-hidden card-retro ${className}`}>
      <motion.img style={{ y }} src={src} alt={alt} className="w-full h-full object-cover scale-110" />
    </div>
  );
};

const CHAPTERS = [
  {
    no: "01",
    title: "How we met",
    body: "It started with a spilled drink and a bad joke at a house party in 2019. Maggie laughed anyway, and Dan has been trying to earn that laugh every day since.",
  },
  {
    no: "02",
    title: "The first road trip",
    body: "Six states, one questionable playlist, and a shared love of roadside diners. Somewhere around Ohio we realized this was the person.",
  },
  {
    no: "03",
    title: "The proposal",
    body: "No drones, no flash mob — just the fireplace, our favorite record, and a very nervous speech that Dan had rehearsed for a month.",
  },
];

export default function Story() {
  return (
    <div>
      <section className="pt-32 md:pt-40 pb-16 max-w-7xl mx-auto px-6 md:px-8">
        <Reveal>
          <p className="overline text-orange">Our Story</p>
          <h1 className="font-display text-5xl sm:text-6xl md:text-8xl text-ink mt-4 leading-[0.95]">
            The long way <br />to the aisle
          </h1>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-8 pb-10">
        <ParallaxPhoto src={IMAGES.hero} alt="Dan and Maggie" className="h-[55vh] md:h-[70vh]" />
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-8 py-16 md:py-28 space-y-24 md:space-y-40">
        {CHAPTERS.map((c, i) => (
          <div key={c.no} className={`grid md:grid-cols-12 gap-10 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`}>
            <Reveal className="md:col-span-6 [direction:ltr]">
              <ParallaxPhoto
                src={i % 2 ? IMAGES.flowers : IMAGES.fireplace}
                alt={c.title}
                className="h-[45vh] md:h-[60vh]"
              />
            </Reveal>
            <Reveal delay={0.12} className="md:col-span-6 [direction:ltr]">
              <p className="font-display text-7xl md:text-8xl text-pink leading-none">{c.no}</p>
              <h2 className="font-grotesk font-extrabold text-3xl md:text-5xl text-ink mt-3 tracking-tight">{c.title}</h2>
              <p className="font-body text-lg text-ink/80 mt-5 max-w-md">{c.body}</p>
            </Reveal>
          </div>
        ))}
      </section>

      <Marquee text="AND THEY LIVED HAPPILY" accent="EVER AFTER STARTS MAY 22" bg="#9C8A30" />
    </div>
  );
}
